import { useState, useRef, useEffect } from 'react';
import { Smile } from 'lucide-react';

interface Props {
  messageId: string;
  onReact: (msgId: string, emoji: string) => void;
}

export function EmojiPickerButton({ messageId, onReact }: Props) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  // Fechar ao clicar fora
  useEffect(() => {
    if (!open) return;
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  const emojis = ['👍', '❤️', '😂', '😮', '😢', '🙏'];

  return (
    <div className="relative" ref={ref}>
      <button 
        onClick={(e) => {
          e.stopPropagation();
          setOpen(!open);
        }}
        className="text-gray-400 hover:text-gray-600 active:scale-95 transition-all p-1.5 rounded-full hover:bg-black/5" 
        title="Reagir"
      >
        <Smile size={16} />
      </button>
      {open && (
        <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1.5 flex bg-white dark:bg-[#233138] border border-gray-200 dark:border-gray-700 rounded-full px-2 py-1 shadow-lg gap-2 z-50">
          {emojis.map(emoji => (
            <button
              key={emoji}
              onClick={(e) => {
                e.stopPropagation();
                onReact(messageId, emoji);
                setOpen(false);
              }}
              className="hover:scale-130 active:scale-90 transition-all text-[15px] px-0.5 leading-none"
            >
              {emoji}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
